export default "{}\n"